import React from 'react';

export type MappingStatus = 'pending' | 'approved' | 'rejected';

const VIEW: Record<MappingStatus, { label: string; fg: string; bg: string }> = {
    approved: { label: 'Approved', fg: '#0F7A5F', bg: '#E3F5EE' },
    rejected: { label: 'Rejected', fg: '#B23A4E', bg: '#FBE7EA' },
    pending: { label: 'Pending', fg: '#5A6473', bg: '#EEF1F5' },
};

export const StatusBadge: React.FC<{ status: MappingStatus }> = ({ status }) => {
    const v = VIEW[status];
    return (
        <span className="text-[11.5px] font-bold px-[10px] py-[3px] rounded-full whitespace-nowrap" style={{ background: v.bg, color: v.fg }}>
            {v.label}
        </span>
    );
};

/** "by Jane · Jul 20" caption for a reviewed row — render under the status pill, not inside it. */
export const ReviewedByCaption: React.FC<{ reviewedByName?: string | null; reviewedAt?: string | null }> = ({ reviewedByName, reviewedAt }) => {
    if (!reviewedByName) return null;
    const date = reviewedAt ? new Date(reviewedAt) : null;
    const dateStr = date && !Number.isNaN(date.getTime())
        ? date.toLocaleDateString(undefined, { month: 'short', day: 'numeric' })
        : null;
    return (
        <div className="text-[10.5px] text-mapper-muted-2 whitespace-nowrap">
            by {reviewedByName}{dateStr ? ` · ${dateStr}` : ''}
        </div>
    );
};
